import styled from 'styled-components';

const SeparatorContainer = styled.div<{ $padding: number }>`
  padding: ${({ theme, $padding }) => theme.unit($padding)} 0;
`;

const SeparatorLine = styled.hr`
  margin: 0;
  border: 0;
  border-top: 1px solid ${(p) => p.theme.c.border.primary};
`;

export const Separator = ({ padding = 2 }: { padding?: number }) => (
  <SeparatorContainer $padding={padding}>
    <SeparatorLine />
  </SeparatorContainer>
);
